import { ROUTER_PATH } from "@config/router";
import { navigateToLoginViaSPA } from "./loginNavigationBus";

function isLoginPath(pathname: string): boolean {
  return (
    pathname === ROUTER_PATH.LOGIN ||
    pathname.startsWith(`${ROUTER_PATH.LOGIN}/`)
  );
}

/** 对外 URL 的 locale 前缀（`/zh-tw/login` → `/login`）；设备段由中间件 rewrite，不出现在地址栏 */
const LOCALE_PREFIX = /^\/[a-z]{2}(?:-[a-z]{2})?\//;

function stripLocalePrefix(pathname: string): string {
  return pathname.replace(LOCALE_PREFIX, "/");
}

/**
 * 当前是否就在独立登录页（`/login` 或带 locale 前缀的 `/xx/login`）。
 * 不含 `/login_popup` 这类同前缀的别的页面，也不含 `/extension/login` 这类别处的 login 段。
 */
export function isLoginPagePath(pathname: string): boolean {
  return isLoginPath(pathname) || isLoginPath(stripLocalePrefix(pathname));
}

/** 构建独立登录页 URL，保留 `is_native_app` 与 dev `harness*` 透传参数 */
function buildLoginPageUrl(): string {
  if (typeof window === "undefined") {
    return ROUTER_PATH.LOGIN;
  }
  const url = new URL(ROUTER_PATH.LOGIN, window.location.origin);
  const current = new URLSearchParams(window.location.search);
  for (const [key, value] of current.entries()) {
    if (key === "is_native_app" || key.startsWith("harness")) {
      url.searchParams.set(key, value);
    }
  }
  return `${url.pathname}${url.search}`;
}

function shouldSkipLoginPageRedirect(pathname: string): boolean {
  return isLoginPagePath(pathname) || pathname.includes(ROUTER_PATH.LOGIN);
}

/** 跳转独立登录页 — 优先 SPA 导航（无白屏），fallback 整页跳转 */
export function redirectToLoginPage(pathname?: string): void {
  if (typeof window === "undefined") {
    return;
  }
  const currentPath =
    pathname ?? window.location.pathname + window.location.search;
  if (shouldSkipLoginPageRedirect(currentPath)) {
    return;
  }
  const loginUrl = buildLoginPageUrl();
  const url = new URL(loginUrl, window.location.origin);
  if (!isLoginPath(currentPath) && !currentPath.startsWith("//")) {
    url.searchParams.set("returnUrl", currentPath);
  }
  const target = `${url.pathname}${url.search}`;
  if (!navigateToLoginViaSPA(target)) {
    window.location.replace(target);
  }
}
